import { InventoryChangeModel } from '../../../../types/InventoryChange';
import { InventoryProductModel } from '../../../../types/InventoryProduct';
import { DBWriterLoggerFunction } from '../../../../types/logger';

export const prepareDeleteInventoryProduct = ({
    inventoryProductElement,
}: {
    inventoryProductElement: InventoryProductModel;
}) => inventoryProductElement.prepareMarkAsDeleted();

export const prepareDeleteInventoryChanges = ({
    relatedInventoryChanges,
}: {
    relatedInventoryChanges: InventoryChangeModel[];
}) =>
    relatedInventoryChanges.map((inventoryChange) =>
        inventoryChange.prepareMarkAsDeleted(),
    );

export const logDeleteInventoryProductActions = ({
    inventoryProductElement,
    inventoryChangesToDelete,
    logDBAction,
    tableName,
}: {
    inventoryProductElement: InventoryProductModel;
    inventoryChangesToDelete: InventoryChangeModel[];
    logDBAction: DBWriterLoggerFunction;
    tableName: string;
}) => {
    if (inventoryChangesToDelete.length > 0) {
        logDBAction({
            message: 'Delete inventory changes related to inventory product',
            modelName: tableName,
            payload: inventoryChangesToDelete,
        });
    }

    logDBAction({
        message: 'Delete inventory product',
        modelName: tableName,
        payload: inventoryProductElement,
    });
};
